import {Findings} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {SplitPageLayout} from '@primer/react'
import {Suspense} from 'react'
import {pullRequestsLayoutRoute} from './layout-route'
import {usePullRequestBasePath} from '../stores/layout-selectors'
import styles from './Findings.module.css'

export const FindingsEntrypoint = () => (
  <ErrorBoundary boundaryName="FindingsEntrypoint" fallback={null}>
    <Suspense fallback={null}>
      <FindingsContent />
    </Suspense>
  </ErrorBoundary>
)

const FindingsContent = () => {
  const basePath = usePullRequestBasePath()
  const {
    data: {aliveChannels},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')

  return (
    <div className="width-full">
      <SplitPageLayout className={styles.wrapper}>
        <Findings pullRequestBasePath={basePath} aliveChannel={aliveChannels.pullRequest} variant="page" />
      </SplitPageLayout>
    </div>
  )
}
